window.ApprovalFlowAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    _protected.setApiUrl(publicConfiguration['ApprovalFlowServer']);

    var approvalFlowSettingsCache = {};
    let approvalsPerBrandPerCodeCache = {};

    self.getApprovalFlows = function (brandId, serviceType, payLoad) {

        if (!brandId) {
            throw "No brand id";
        }

        serviceType = serviceType || 'JOB_APPROVAL_FLOW';

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/approval_flows', 'GET', payLoad)
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getApprovalFlowsSettings = function (brandId, serviceType, loadApprovalSettings) {

        if (!brandId) {
            throw "No brand id";
        }

        serviceType = serviceType || 'JOB_APPROVAL_FLOW';
        let brandServiceCacheKey = `${brandId}_${serviceType}`;
        if (approvalsPerBrandPerCodeCache[brandServiceCacheKey] && !loadApprovalSettings) {
            return $q.resolve(approvalsPerBrandPerCodeCache[brandServiceCacheKey]);
        } else {
            let defer = $q.defer();

            _protected.request(`brands/${brandId}/services/${serviceType}/settings`, 'GET')
                .then((res) => {
                    if (res && res.data) {
                        approvalsPerBrandPerCodeCache[brandServiceCacheKey] = res.data.data;
                        defer.resolve(res.data.data);
                    } else {
                        defer.reject(res);
                    }
                })
                .catch((err) => {
                    defer.reject(err);
                });

            return defer.promise;
        }
    };

    self.getBrandApprovalFlowSettings = function (brandId) {
        if (!brandId) {
            throw "No brand id";
        }

        var defer = $q.defer();

        if (approvalFlowSettingsCache[brandId]) {
            defer.resolve(approvalFlowSettingsCache[brandId]);
            return defer.promise;
        }

        _protected.request('brands/' + brandId + '/settings', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data) {
                    approvalFlowSettingsCache[brandId] = res.data.data;
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    }


    self.addApprovalFlow = function (brandId, serviceType, payload) {

        if (!brandId) {
            throw "No brand id";
        }

        serviceType = serviceType || 'JOB_APPROVAL_FLOW';

        if (payload['categories'] && payload['categories'].length === 0) {
            delete payload['categories'];
        }

        if (payload['positions'] && payload['positions'].length === 0) {
            delete payload['positions'];
        }


        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/approval_flows', 'POST', payload)
            .then(function (res) {
                if (res && res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.enableApprovalFlowCustomization = function (brandId, serviceType) {

        if (!brandId) {
            throw "No brand id";
        }

        serviceType = serviceType || 'JOB_APPROVAL_FLOW';

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/approval_flows/enable_customization', 'POST')
            .then(function (res) {
                if (res && res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.disableApprovalFlowCustomization = function (brandId, serviceType) {

        if (!brandId) {
            throw "No brand id";
        }

        serviceType = serviceType || 'JOB_APPROVAL_FLOW';

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/approval_flows/disable_customization', 'POST')
            .then(function (res) {
                if (res && res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.editApprovalFlow = function (brandId, serviceType, approvalFlowId, payload) {

        if (!brandId) {
            throw "No brand id";
        }

        if (!approvalFlowId) {
            throw "No approval flow id";
        }
        if (payload['categories'] && payload['categories'].length === 0) {
            delete payload['categories'];
        }

        if (payload['positions'] && payload['positions'].length === 0) {
            delete payload['positions'];
        }


        serviceType = serviceType || 'JOB_APPROVAL_FLOW';

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/approval_flows/' + approvalFlowId, 'PUT', payload)
            .then(function (res) {
                if (res && res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.removeApprovalFlow = function (brandId, serviceType, approvalFlowId) {

        if (!brandId) {
            throw "No brand id";
        }

        if (!approvalFlowId) {
            throw "No approval flow id";
        }

        serviceType = serviceType || 'JOB_APPROVAL_FLOW';

        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/approval_flows/' + approvalFlowId, 'DELETE')
            .then(function (res) {
                if (res && res.status === 200 && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res.data);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getOperationEntities = function (brandId, serviceType, params) {
        if (!brandId) {
            throw "No brand id";
        }
        var defer = $q.defer();

        serviceType = serviceType || 'JOB_APPROVAL_FLOW';

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/operation_entities', 'GET', params)
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getOperationApprovalFlowForEntity = function (brandId, entityId, serviceType, entityType) {
        var defer = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        if (!entityId) {
            throw "No entity id";
        }
        var params = (serviceType === 'TEAMLIVE_POSITION' ? ('?entity_type=' + entityType) : '');

        serviceType = serviceType || 'JOB_APPROVAL_FLOW';

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/operation_entities/entities/' + entityId + '/operation_approval_flows/latest' + params, 'GET')
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.approveEntity = function (brandId, entityId, serviceType, entityType) {
        var defer = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        if (!entityId) {
            throw "No brand id";
        }

        var params = (serviceType === 'TEAMLIVE_POSITION' ? ('?entity_type=' + entityType) : '');

        serviceType = serviceType || 'JOB_APPROVAL_FLOW';
        _protected.request('brands/' + brandId + '/services/' + serviceType + '/operation_entities/entities/' + entityId +
        '/operation_approval_flows/latest/approve' + params, 'POST')
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.rejectEntity = function (brandId, entityId, serviceType, entityType, payLoad) {
        if (!brandId) {
            throw "No brand id";
        }
        if (!entityId) {
            throw "No entity id";
        }
        var params = (serviceType === 'TEAMLIVE_POSITION' ? ('?entity_type=' + entityType) : '');
        var defer = $q.defer();
        serviceType = serviceType || 'JOB_APPROVAL_FLOW';
        _protected.request('brands/' + brandId + '/services/' + serviceType + '/operation_entities/entities/' + entityId + '/operation_approval_flows/latest/reject' + params, 'POST', payLoad)
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getEntityOwners = function (brandId, serviceType) {
        if (!brandId) {
            throw "No brand id";
        }
        var defer = $q.defer();
        serviceType = serviceType || 'JOB_APPROVAL_FLOW';

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/operation_entities/operation_approval_flows/owners', 'GET')
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getEntityApprovalDetails = function (brandId, entityId, serviceType) {
        if (!brandId) {
            throw "No brand id";
        }

        if (!entityId) {
            throw "No Entity id";
        }
        var defer = $q.defer();
        var params = {entity_ids: entityId};

        serviceType = serviceType || 'JOB_APPROVAL_FLOW';

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/operation_entities', 'GET', params)
            .then((res) => {
                const entity = res?.data?.data?.operation_entities?.[0];
                if (entity) {
                    defer.resolve(entity);
                } else {
                    console.error("Error, entity not found, for entity id:", entityId);
                    defer.reject({code: 'JOB_NOT_FOUND'});
                }
            })
            .catch((err) => {
                defer.reject(err);
            });


        return defer.promise;

    };

    self.CheckEntityLastVersion = function (brandId, entityId, flowId, serviceType, entityType) {
        var defer = $q.defer();
        if (!brandId) {
            throw "No brand id";
        }
        if (!entityId) {
            throw "No entity id";
        }
        if (!flowId) {
            throw "No flow id";
        }
        var params = (serviceType === 'TEAMLIVE_POSITION' ? ('?entity_type=' + entityType) : '');

        serviceType = serviceType || 'JOB_APPROVAL_FLOW';

        _protected.request('brands/' + brandId + '/services/' + serviceType + '/operation_entities/entities/' + entityId + '/operation_approval_flows/' + flowId + '/check_version' + params, 'GET')
            .then(function (res) {
                if (res && res.data) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };
});

ApprovalFlowAPI.MODES = {
    MANAGEMENT: 'MANAGEMENT'
}
